import { getServices } from '~/db/services';

export const useApiFetchCache = async (
  url: string,
  maxDuration: number = 24 * 60 * 60
) => {
  const { $db } = useNuxtApp();

  const { cacheService } = getServices($db);

  const chacheFromNetwork = async () => {
    const { result, error } = await useApiFetch(URI.MemberPreferences, {
      method: 'GET',
    });
    if (result) {
      cacheService.put({
        key: url,
        time: new Date().getTime(),
        data: result,
      });
    }
    return {
      result,
      error,
    };
  };

  const cached = await cacheService.get(url);

  if (!cached || cached.time + maxDuration < new Date().getTime()) {
    return chacheFromNetwork();
  }

  return {
    result: cached.data,
    error: null,
  };
};
